import EnemyType from "../../enums/EnemyType";
import EnemyData from "./EnemyDataInterface";

const SPECIAL_ENEMYS: {
  [key in EnemyType]?: EnemyData[];
} = {
  [EnemyType.CAMEL]: [
    {
      level: 1,
      maxHp: 1.5,
      speed: 150,
      power: 0,
      knockback: 0,
      deathKB: 2,
      xp: 1,
      killedAmount: 0,
      scale: 1,
      spriteName: "camel",
      animationKey: "camel_run",
      skills: ["FixedDirection", "DropCoin", "DropCamelChest"],
    },
  ],
  [EnemyType.CAMEL_CARAVAN]: [
    {
      level: 1,
      maxHp: 1.5,
      speed: 200,
      power: 0,
      knockback: 0,
      deathKB: 2,
      xp: 1,
      killedAmount: 0,
      scale: 1,
      spriteName: "camel",
      animationKey: "camel_run",
      skills: ["FixedDirection", "DropCoin", "Caravan", "DropCamelChest"],
    },
  ],
};

export default SPECIAL_ENEMYS;
